import { Component, Input, OnInit, TemplateRef } from '@angular/core';

import { GenericValue, HisUploadFile } from 'hisng';

import { DocumentMetadataCategoryService } from '../../../service/documents/documentMetadataCategory.service';
import { ProviderManager } from '../../../utils/provider-manager';
import { DynamicAttributeSummarizedItem } from '../../../model/dynamic-viewitem/DynamicAttributeSummarizedItem';

@Component({
    selector: 'res-documents-view-summary',
    templateUrl: './documents-view-summary.component.html',
    providers: [ProviderManager.getComponentProvider(DocumentsViewSummaryComponent)],
})
export class DocumentsViewSummaryComponent implements OnInit {
    @Input() documents: HisUploadFile[];
    @Input() targetConfKey: string;
    @Input() dynamicAttributeItems: DynamicAttributeSummarizedItem[];
    @Input() viewDynamicItemsTemplate: TemplateRef<any>;
    
    allowedCategories:GenericValue[];
            
    public documentCategoriesMap: Map<number, string>;

    constructor(private documentMetadataCategoryService: DocumentMetadataCategoryService ) { }
    
    ngOnInit() {
        if ( this.documents ) {
            this.documentCategoriesMap = new Map<number, string>();
            this.documentMetadataCategoryService.getDocumentCategoriesByConfkey( this.targetConfKey ).subscribe(
                ( documentCategories: GenericValue[] )  => { 
                    this.allowedCategories = documentCategories;
                    //console.log('#########allowedCategories',this.allowedCategories );   
                    this.documents.forEach( ( document: HisUploadFile ) => {
                        let allowedCategory = this.allowedCategories.find(
	                        ( category: GenericValue ) => category.id === document.documentMetadataCategoryId );
	                    if (allowedCategory) {    
                            this.documentCategoriesMap.set(document.id, allowedCategory.defaulttext );
                        }
                    });
                });                
        }
    }

}
